import {useEffect} from 'react';

import SwitchLang from '@/components/SwitchLang';
import {handleCanceledAccount} from '@/helper';
import {initMonitor} from '@/util';
import Main from '../Core/Main';
import LeftWrap from '../Core/LeftWrap';
import RightWrap from '../Core/RightWrap';
import {initPass, initUC} from './pc-init';
import './styles';

export default function App() {
    useEffect(() => {
        initMonitor();
        handleCanceledAccount();
    }, []);
    return (
        <Main>
            <div className="page-wrap">
                <div className="choice-language" id="choice-language">
                    <SwitchLang
                        items={[
                            {
                                label: '简体中文',
                                key: 'zh-CN',
                                onClick: () => {
                                    location.href = '/';
                                },
                            },
                            {
                                label: 'English',
                                key: 'en',
                                onClick: () => {
                                    location.href = '/?lang=en';
                                },
                            },
                        ]}
                    />
                </div>
                <LeftWrap />
                <RightWrap extraClassName="" initPass={initPass} initUC={initUC} />
            </div>
        </Main>
    );
}
